// extracted by mini-css-extract-plugin
export default {"todoSecWrapper":"Todo_todoSecWrapper__1Lls-","todoMainTitle":"Todo_todoMainTitle__wKWlF"};